module.exports = __webpack_public_path__ + "img/picture_0.6ec0ce35.png";